import { TrendingDown, TrendingFlat, TrendingUp } from "@mui/icons-material";

export interface TrendIconProps {
  trendPercentage: number;
}

export const TrendIcon = ({ trendPercentage }: TrendIconProps) => {
  if (trendPercentage > 0) {
    return <TrendingUp fontSize="small" color="success" />;
  }
  if (trendPercentage < 0) {
    return <TrendingDown fontSize="small" color="error" />;
  }
  return <TrendingFlat fontSize="small" color="disabled" />;
};
